// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xfZs","colMin":"styles_colMin__3D0R7"};